
namespace GeniuzPOS.Purchase {
    @Serenity.Decorators.registerClass()
export class ReportPendingPODtEditor extends Serenity.Extensions.GridEditorBase<ReportPendingPODtRow> {
    protected getColumnsKey() { return ReportPendingPODtColumns.columnsKey; }
    protected getDialogType() { return ReportPendingPODtDialog; }
    protected getLocalTextPrefix() { return ReportPendingPODtRow.localTextPrefix; }


    constructor(container: JQuery) {
        super(container);
    }
    protected getButtons() {
        var buttons = super.getButtons();

        // remove first button (Add button)
        buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
        buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'column-picker-button'), 1)

        // Add buttons import excel, pdf      
        
       
        return buttons;
    }


    protected getSlickOptions() {
        var opt = super.getSlickOptions();
        opt.showFooterRow = true;
        // opt.frozenColumn = 1;
        return opt;
    }

    protected getViewOptions() {
        var opt = super.getViewOptions();
        opt.localSort = true;
        return opt;
    }

    protected usePager() {
        return false;
    }

    
}}